import { Controller } from '@hotwired/stimulus';
import TomSelect from 'tom-select';

function wordStartScore(query) {
  const escaped = query.trim().replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
  const regex = new RegExp(`(^|\\s|\\b)${escaped}`, 'i');
  return (item) => (regex.test(item.text) ? 1 : 0);
}

export default class extends Controller {
  static values = {
    exclude: Array,
    searchable: { type: Boolean, default: true },
    clearable: { type: Boolean, default: false },
    allowEmptyOption: { type: Boolean, default: false },
    dropdownInput: { type: Boolean, default: false },
    legacySearch: { type: Boolean, default: true },
  };

  connect() {
    const plugins = this.element.multiple ? ['remove_button'] : [];
    if (this.clearableValue) plugins.push('clear_button');
    if (this.dropdownInputValue) plugins.push('dropdown_input');

    this.select = new TomSelect(this.element, {
      plugins,
      allowEmptyOption: this.allowEmptyOptionValue,
      maxOptions: 200,
      ...(this.legacySearchValue && {
        // Chosen rendered every option; Tom Select caps the list.
        maxOptions: null,
        // Listing $score stops Tom Select ranking by relevance first, so options keep server order.
        sortField: [{ field: '$order' }, { field: '$score' }],
        // Chosen matched the whole query as a phrase at a word start; Tom Select matches words anywhere.
        score: wordStartScore,
      }),
    });

    // Chosen exposed `${id}_chosen`; server-side anchors and specs need an equivalent.
    if (this.element.id) this.select.wrapper.id = `${this.element.id}_wrapper`;

    if (!this.searchableValue) this.select.control_input.readOnly = true;
    this.excludeValue.forEach((value) =>
      this.select.removeOption(String(value)),
    );

    // Tom Select hides the real <select>, so focusout never reaches it and the form
    // validation controller would never see the field being left.
    this.select.on('blur', () => {
      this.element.dispatchEvent(new Event('focusout', { bubbles: true }));
    });
  }

  disconnect() {
    if (this.select) this.select.destroy();
  }
}
